module.exports = __webpack_public_path__ + "img/02d5a5e.png";